import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Header from './components/header';
import Footer from './components/footer';
import Regulation from './pages/regulation';
import Terms from './pages/terms';
import Project from './pages/project';  
import About from './pages/about';
import Contact from './pages/contact'
import Books from './pages/books';
import Blog from './pages/blog';
import Post from './pages/post';

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/regulation" element={<Regulation />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/project" element={<Project />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/books" element={<Books />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Post />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;